import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberAbbreviate',
  standalone: true,
})
export class NumberAbbreviatePipe implements PipeTransform {
  transform(value: number | string): string {
    if (value === null || value === undefined || value === '') return '';
    let num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num)) return '';
    const absNum = Math.abs(num);
    if (absNum < 1000) return num.toString();
    if (absNum < 1_000_000)
      return (
        (num / 1_000).toFixed(absNum < 10_000 ? 1 : 0).replace(/\.0$/, '') + 'K'
      );
    if (absNum < 1_000_000_000)
      return (
        (num / 1_000_000)
          .toFixed(absNum < 10_000_000 ? 1 : 0)
          .replace(/\.0$/, '') + 'M'
      );
    return (
      (num / 1_000_000_000)
        .toFixed(absNum < 10_000_000_000 ? 1 : 0)
        .replace(/\.0$/, '') + 'B'
    );
  }
}
